import * as React from 'react';

import * as main from '../../../styles/mainOld.module.scss';
import * as howWorks from './howWorks.module.scss';

export const HowWorksOld = () => {
  return (
    <section className={howWorks.howWorks}>
      <div className="container">
        <h2 className={`${howWorks.howWorks__title} ${main.mainTitle}`}>
          Курс устроен так, чтобы ребенку не&nbsp;было скучно
        </h2>
        <div className={`row ${howWorks.howWorks__row}`}>
          <div className={`col-12 col-md-6 ${howWorks.howWorks__col}`}>
            <div className={howWorks.howWorks__wrapper}>
              <h3 className={howWorks.howWorks__subtitle}>Интересная игра с&nbsp;сюжетом</h3>
              <p className={howWorks.howWorks__text}>
                Уроки&nbsp;— это набор игровых видеороликов. По сюжету, ребенок собирает знания, чтобы выковать
                собственное счастье. Профессиональные рассказчики проводят ребенка по&nbsp;каждому из этапов игры&nbsp;—
                модулей курса.
              </p>
            </div>
          </div>
          <div className={`col-12 col-md-6 ${howWorks.howWorks__col}`}>
            <img
              src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_old/how-works-img.jpg"
              alt={'Пример из видео-урока'}
            />
            <p className={`${howWorks.howWorks__text} ${howWorks.howWorks__textSmall}`}>Пример одного из уроков</p>
          </div>
          <div className={`col-12 col-md-6 ${howWorks.howWorks__col}`}>
            <div className={howWorks.howWorks__wrapper}>
              <h3 className={howWorks.howWorks__subtitle}>Не помешает учебе в&nbsp;школе</h3>
              <p className={howWorks.howWorks__text}>
                Курс рассчитан на&nbsp;160-200&nbsp;часов. В&nbsp;среднем урок длится 30&nbsp;минут, в&nbsp;конце
                каждого урока&nbsp;— тест. Весь курс рассчитан на&nbsp;год, так что его можно проходить,
                не&nbsp;отрываясь от&nbsp;школьных занятий.
              </p>
            </div>
          </div>
          <div className={`col-12 col-md-6 ${howWorks.howWorks__col}`}>
            <div className={main.sideData}>
              <p className={main.sideData__bigText}>
                <span className={main.sideData__bigTextAccent}>30</span> минут
              </p>
              <p className={main.sideData__smallText}>длится один урок</p>
            </div>
          </div>
          <div className={`col-12 col-md-6 ${howWorks.howWorks__col}`}>
            <div className={howWorks.howWorks__wrapper}>
              <h3 className={howWorks.howWorks__subtitle}>Интерактивная платформа</h3>
              <p className={howWorks.howWorks__text}>
                У каждого задания три уровня сложности, как в&nbsp;компьютерной игре. Ребёнок сам выбирает подходящий
                уровень.
              </p>
              <p className={howWorks.howWorks__text}>
                Время выполнения упражнений и&nbsp;общий прогресс фиксируются в&nbsp;специальном разделе платформы.
                Ребёнок видит динамику результатов, это мотивирует продолжать.
              </p>
            </div>
          </div>
          <div className={`col-12 col-md-6 ${howWorks.howWorks__col}`}>
            <div className={howWorks.howWorks__wrapper}>
              <h3 className={howWorks.howWorks__subtitle}>Сопровождение куратора</h3>
              <p className={howWorks.howWorks__text}>
                На всем пути ребёнка сопровождает куратор. Он проверяет выполненные задания, дает обратную связь,
                отвечает на&nbsp;вопросы, в&nbsp;том числе от&nbsp;родителей.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
